import { ThemeUICSSObject } from '@apia/theme';

const fields: ThemeUICSSObject = {
  variant: 'layout.forms.select',
  background: 'red',
};

export default fields;
